import {
  type RumEvent,
  type RumEventDomainContext,
} from '@datadog/browser-rum';

import { CART_ID, REGION } from '@/utils/constants/cookies';
import { cookies } from '@/utils/cookies';

export function beforeSend(event: RumEvent, context: RumEventDomainContext) {
  event.context = {
    ...event.context,
    regionId: cookies.client.get(REGION).value ?? 'Unknown region',
    cartId: cookies.client.get(CART_ID).value ?? 'Empty cartId',
  };

  return true;
}
